import { agentTrainingRealtime } from '@/services/AgentTrainingRealtime';
import { useAgentTraining } from '@/store/agent-training.ts';
import useAppStore from '@/store/app';

export const resetStepperRuntime = (): void => {
	agentTrainingRealtime.disconnect();
	useAppStore.getState().resetState();
	useAgentTraining.getState().resetState();
};
